<template>
    <v-card>
        <v-card-title>Historical Alarm Params</v-card-title>

        <v-card-text>
            <v-form ref="historicalParams" v-model="historicalParamsFormValid" :lazy-validation="true">
                <v-row dense >

                <v-col cols="12" md="6">
                    <v-datetime-picker label="Start Date/Time" v-model="historicalParams.startDateTime" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps"></v-datetime-picker>
                </v-col>
                <v-col cols="12" md="6">
                    <v-datetime-picker label="End Date/Time" v-model="historicalParams.endDateTime" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps"></v-datetime-picker>
                </v-col>

                <v-col cols="12">
                    <v-radio-group v-model="historicalParams.rawProcessed" row>
                    <v-radio label="Raw Alarms" value="raw" color="#c42111"></v-radio>
                    <v-radio label="Processed Alarms" value="processed" color="#c42111"></v-radio>
                    </v-radio-group>
                </v-col>

                <v-col cols="12">
                    <span>Enter the parameters on which you want to filter alarms or leave a parameter blank to not filter on that parameter. An asterisk (*) can be used to match patterns</span>
                </v-col>

                <v-col cols="12" md="6">
                    <v-text-field label="Office" v-model="historicalParams.office" color="#c42111"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field label="Location" v-model="historicalParams.location" color="#c42111"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field label="Code/Phrase" v-model="historicalParams.codePhrase" color="#c42111"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-select label="Severity" multiple v-model="historicalParams.severity" :items="severityList" color="#c42111"></v-select>
                </v-col>
                <v-col cols="12" md="6">
                    <v-select label="Technician" multiple v-model="historicalParams.technician" :items="technicianList" color="#c42111"></v-select>
                </v-col>
                <v-col cols="12" md="6">
                    <v-select label="Locale" multiple v-model="historicalParams.locale" :items="localeList" color="#c42111"></v-select>
                </v-col>
                <v-col cols="12" md="6">
                    <v-autocomplete label="Paged To" multiple v-model="historicalParams.pagedTo" :items="pagedUserList" color="#c42111" />
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field label="Remarks" v-model="historicalParams.remarks" color="#c42111"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-select label="Acked By" multiple v-model="historicalParams.ackedBy" :items="ackedUserList" color="#c42111"></v-select>
                </v-col>
                <v-col cols="12" md="6">
                    <v-select label="Cleared By" multiple v-model="historicalParams.clearedBy" :items="clearedUserList" color="#c42111"></v-select>
                </v-col>

                </v-row>
            </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="runClick">Run</v-btn>
            <v-btn text @click="$emit('cancel')">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'HistoricalParams',
    props: ['historicalAlarmsParams', 'historicalParamsResources'],
    components: {

    },
    data: () => ({
        historicalParamsFormValid: true,
        tpProps: {
            useSeconds: true,
            format: '24hr',
            color: '#c42111'
        },
        dpProps: {
            color: '#c42111'
        },
        severityList: ['CRITICAL', 'MAJOR', 'MINOR', 'OBSERVATIONAL'],
        technicianList: [],
        localeList: [],
        pagedUserList: [],
        ackedUserList: [],
        clearedUserList: [],
        historicalParams: {
            startDateTime: TELSA.moment().startOf('day').subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
            endDateTime: TELSA.moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            rawProcessed: 'processed',
            office: '',
            location: '',
            codePhrase: '',
            severity: '',
            technician: '',
            locale: '',
            pagedTo: '',
            ackedBy: '',
            clearedBy: '',
            remarks: ''
        }
    }),

    computed: {
    },

    methods: {
        getResources: function() {
            if(this.$props.historicalParamsResources) {
                this.applyResources(this.$props.historicalParamsResources);
            }
            else {
                let route = (TELSA.apiHost + "alarms/historicalresources");
                TELSA.loading(true);
                return this.$http.get(route).then(response => {
                    let result = response.body;
                    this.applyResources(result);
                    this.$emit('setResources', result);
                    TELSA.loading(false);
                });
            }
        },

        applyResources: function(resources) {
            this.technicianList = resources.technician_list;
            this.localeList = resources.locale_list;
            this.pagedUserList = resources.paged_user_list;
            this.ackedUserList = resources.acked_user_list;
            this.clearedUserList = resources.cleared_user_list;
        },

        runClick: function() {
            if(this.historicalParams.startDateTime && this.historicalParams.endDateTime) {
                this.$emit('run', this.historicalParams);
            }
            else {
                this.$store.commit('showConfirmModal', {
                    title: 'Missing Required Fields',
                    message: `You must fill out a Start Date/Time and End Date/Time`,
                    type: 'warning',
                    hideCancel: true,
                    confirmAction: () => {}
                });
            }
        }
    },

    created() {
    },

    mounted() {
        if(this.$props.historicalAlarmsParams) {
            this.historicalParams = this.$props.historicalAlarmsParams;
        }
        this.getResources();
    }

  
}
</script>

<style scoped>


</style>
